import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              热播排行
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              实时热度榜单，看看大家都在追什么
            </p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
            {rankingItems.map((item, index) => (
              <div
                key={item.title}
                className={`flex items-center gap-3 md:gap-5 p-4 md:p-5 ${
                  index < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                } hover:bg-background-100 transition-colors duration-200 cursor-pointer`}
              >
                <div className="flex-shrink-0 w-8 md:w-10 text-center">
                  {item.rank <= 3 ? (
                    <span
                      className={`inline-flex items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-md text-sm md:text-base font-heading text-background-50 ${
                        item.rank === 1
                          ? 'bg-accent-500'
                          : item.rank === 2
                            ? 'bg-primary-500'
                            : 'bg-secondary-500'
                      }`}
                    >
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-base md:text-lg font-heading text-foreground-400">
                      {item.rank}
                    </span>
                  )}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="text-sm md:text-base font-heading text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    {item.trend === 'new' && (
                      <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                        NEW
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-foreground-400 truncate">
                    {item.category} · {item.description}
                  </p>
                </div>

                <div className="flex-shrink-0 flex items-center gap-2 md:gap-3">
                  <span className="text-sm md:text-base font-heading text-primary-600 whitespace-nowrap">
                    {item.score}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">分</span>
                  {item.trend !== 'new' && (
                    <span
                      className={`text-sm ${
                        item.trend === 'up' ? 'text-accent-500' : 'text-foreground-400'
                      }`}
                    >
                      {item.trend === 'up' ? (
                        <i className="ri-arrow-up-line"></i>
                      ) : (
                        <i className="ri-subtract-line"></i>
                      )}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}